export default __webpack_public_path__ + "static/Marty_Sattison_flags_social-2da36ceca6cc462ffccdceec846d0056.jpg";